import React, { ComponentType } from "react";
import _ from "lodash";
import { withRouter, RouteChildrenProps } from "react-router";
import { compose } from "redux";
import { withStore, StoreProps } from "../../store";
import Fetch from "./Fetch";
import { Player } from "../Overlays";
import LivePlayer from "../LivePlayer/LivePlayer";
import { cleanUrl, getDateString, Constants, User, evergentRequest } from "../../utilities";
import { DEFAULT_HEADERS, LANGUAGE_PATH_REGEX } from "../../constants";
import Modal from "../Modals/Modal";
import { Button } from "../Buttons";
import { setStorageItem } from "../../utilities/index";
import jwt_decode from "jwt-decode";
import "../Modals/UnifiSignInModal/UnifiSignInModal.scss";

type RouteProps = RouteChildrenProps<{}, { fromRecommendation?: string }>;

interface ContentFetchProps {
  viewAllPath?: string | null;
  pathname?: string;
  setIsAbroadFlag?: (isAbroad: boolean) => void;
  onComplete?: (data?: any) => void;
  children: (errors?: any[], screen?: any) => React.ReactNode;
  isContinueWatching?: boolean;
};

interface ContentFetchState {
  positionDataLoaded: boolean;
  message: string | null;
  switchUser: boolean;
  ssoToken: string | null;
}

class ContentFetch extends React.Component<ContentFetchProps & RouteProps & StoreProps, ContentFetchState> {
  refetch;
  private isTvGuideEventSent: boolean = false;
  private cacheBusted: boolean = false;
  private cacheBustParam: string = User.authenticated() ? `&cache_bust=${Date.now()}` : '';

  constructor(props) {
    super(props);
    this.state = {
      message: null,
      positionDataLoaded: false,
      switchUser: false,
      ssoToken: null
    };
  }

  removeSsoTokenFromUrl = () => {    
    const { history, location } = this.props;
    const path = location.pathname + location.hash;
    history.replace(path);
  }

  handleAuthenticatedUser = async (token) => {
    const body = {
      "CheckPartnerAndValidateUserRequestMessage" : {
        "userSSOToken": token,
        "partnerName": "unifi"
      }
    }
    const message = await evergentRequest(Constants.CheckPartnerAndValidateUserUrl, body, "CheckPartnerAndValidateUserResponseMessage"); 
    const { status, switchUser, cpIdInSSOToken } = message;
    const { store: { country } } = this.props;
    if(country === 'MY' && status.toLowerCase() === 'success' && switchUser.toLowerCase() === 'true') {
      let switchMessage = ''
      if(User.provider() && ["TMNET", "HYPP TV", "HYPPTV", "UNIFI"].includes(User.provider())) {
        switchMessage = `You're signed in as ${User.id()} do you want to continue or switch to ${cpIdInSSOToken}?`
      } else {
        switchMessage = `You're signed in with a different ID. Do you want to continue or switch to ${cpIdInSSOToken}?`
      }
      this.setState({
        message : switchMessage,
        switchUser : true,
        ssoToken : token
      })
    } else if (status.toLowerCase() === 'success' && switchUser.toLowerCase() === 'false') {
      this.setState({
        switchUser : false
      })
      this.removeSsoTokenFromUrl();
    } 
  }

  handleNonAuthenticatedUser = async (token) => {
    const body = {
      "AuthenticateCustomerForPartnerRequestMessage" : {
        "channelPartnerID": "HYPPTV",
        "userSSOToken": token,
        "partnerName": "unifi"
      }
    }
    const message = await evergentRequest(Constants.AuthenticateCustomerForPartnerUrl, body, "AuthenticateCustomerForPartnerResponseMessage");
    const { status, accessToken, refreshToken } = message;
    const { signIn, store: { country } } = this.props;
    if(status.toLowerCase() === 'success' && country === 'MY') {
      const decodedToken = jwt_decode(accessToken);
      signIn(accessToken,'Bearer', decodedToken.exp);    
      setStorageItem("operator", 'tm', true);
    }
  }

  componentDidMount = async () => {
    const query = new URLSearchParams(this.props.location.search);
    const token = query.get('token');
    if (token && User.authenticated()) {
      await this.handleAuthenticatedUser(token); 
    } else if (token && !User.authenticated()) {
      await this.handleNonAuthenticatedUser(token);
      this.removeSsoTokenFromUrl();
    }    
  }

  fetchPositionData = async () => {
    if (!window.positionData && User.authenticated()) {
      window.positionData = {};
      try {
        const res = await fetch(Constants.XDRGetAllPlaybackPosition, {
          method: "GET",
          headers: {
            ...DEFAULT_HEADERS,
            "Content-Type": "application/json",
            "Authorization": `Bearer ${User.token()}`
          },
        });

        const data = await res.json();
        data?.items.forEach(item => {
          if (item?.video_id && item?.playhead_seconds) {
            window.positionData[item.video_id] = item.playhead_seconds;
          }
        });
      } catch (err) {
        console.error("Error fetching playback position data:", err);
      }
    }

  };

  componentDidUpdate(prevProps) {
    const { store: { video: prevVideo } } = prevProps;
    const { store: { video, isAbroad }, history, location: { search, pathname, state = {} } } = this.props;

 

    // Navigate to player route if not already at it
    if(!prevVideo && video && !search.includes("player") ) {
      if (isAbroad)
        history.push(`${pathname}`);
      else if (video.openLivePlayer) history.push(`${pathname}?liveplayer`);
      else history.push(`${pathname}?player`);
    }
    // Reload content screen after playback has ended to get the latest progress info
    else if(prevVideo && !video && !state.fromRecommendation) {
      this.refetch && this.refetch();
    }
  }

  formatData = (res,isBrand) => {
    if (this.isTvGuide()) {
      return res;
    }
    if (this.props.isContinueWatching) {
      return res;
    }
    if (!!this.props.viewAllPath) {
      return _.get(res, "page");
    }

    const toPick = isBrand ? "content" : "page";

    return _.get(res, toPick);
  }

  onComplete = async (data) => {  
    await this.fetchPositionData();
    const isBrand  =  window.location.pathname.includes('brand') ? true : false 

    const { onComplete, store: { country }, setIsAbroadFlag } = this.props;
    if(country){
      setIsAbroadFlag?.(!["MY", "SG"].includes(country)? true : false);
    }
    let isTvGuidePage = this.isTvGuide();
    
    if(isTvGuidePage && data  ) {
      //ErrorPortal.error(ErrorType.SomethingWrong);
      if (!this.isTvGuideEventSent) {
        onComplete && onComplete(this.formatData(data,isBrand));
        this.isTvGuideEventSent = true;
      }
    } else if (!isTvGuidePage && data  && data.page === null ) {

    }
    else {
      onComplete && onComplete(this.formatData(data,isBrand));
    }
  }

  isTvGuide = () => {
    const { pathname = window.location.pathname } = this.props;
    return pathname.includes( '/live/guide')
  }

  componentWillUnmount() {
    this.isTvGuideEventSent = false;
  }

  handleSwitch = async () => {
    const token = this.state.ssoToken;
    await this.handleNonAuthenticatedUser(token);
    console.log(`switching user successful: ${User.token()} - hasSubscription: ${await User.hasExpiredFreeTrial()}`);
    this.setState({
      switchUser : false,
    })
    this.removeSsoTokenFromUrl();
  }

  handleContinue= () => {
    this.setState({
      switchUser : false,
    })
    if (User.provider() && ["TMNET", "HYPP TV", "HYPPTV", "UNIFI"].includes(User.provider())) {
      this.removeSsoTokenFromUrl();
    } else {
      this.props.history.replace('/');
    }    
  }
  
  render() {
    const { 
      pathname = window.location.pathname, 
      children, 
      store: { video, isAbroad }, 
      location: { search },
      viewAllPath,
      isContinueWatching
    } = this.props;

    const pathWithoutLanguageCode = pathname.replace(LANGUAGE_PATH_REGEX, '');

    const path = `/contentitem/${cleanUrl(pathname)}`.replace(/\/{2,}/g,"/");

    const isBrand  =  !!window.location.pathname.includes('brand') && !viewAllPath; 

    let newPath;
    if (isBrand) {
      newPath =`/content?path=${encodeURIComponent("/" + pathWithoutLanguageCode)}`;
    } else if (viewAllPath) {
      
      if (!isContinueWatching) {
        newPath = `/content/page?id=${viewAllPath}&path=${viewAllPath}&viewAll=${viewAllPath}`;
      } else {
        newPath = viewAllPath;
      }
      
    } else {
        newPath = `/content/page?path=${encodeURIComponent(pathWithoutLanguageCode)}`;
    }
    const offsetInMinutes = new Date().getTimezoneOffset();
    const tvGuideUrl = `${import.meta.env.VITE_NEW_MIDDLEWARE_URL}/schedules?type=guide&date=${getDateString()}&platform=web&offset=${-offsetInMinutes}`;

    const url = this.isTvGuide() ? tvGuideUrl:`${import.meta.env.VITE_NEW_MIDDLEWARE_URL}${newPath}`; 
    const { message, switchUser } = this.state;
    return (
      switchUser ?
      <Modal>
        <div className="UnifiSignInModal">
            <div className="UnifiSignInModal__message">{message}</div>
            <Button text="Continue" onClick={this.handleContinue}/>
            <Button text="Switch Id" grey onClick={this.handleSwitch}/>
        </div>       
      </Modal>
      : !video ?
        <Fetch url={url} onComplete={this.onComplete}>
          {(_, errors, data, status, refetch) => {
            this.refetch = refetch;
            if (typeof children === 'function') {
              return children(errors, this.formatData(data, isBrand));
            }
          }}
        </Fetch>
      : video.openLivePlayer ? !isAbroad && <LivePlayer /> 
      : !!video ?
      !isAbroad && <Player />
      : null
    )
  }
};

export default compose<ComponentType<ContentFetchProps>>(withRouter, withStore)(ContentFetch);
